import SourceAnalytics from './SourceAnalytics.vue'

export const routes = [
  {
    path: '/analytics/sources',
    name: 'analytics.sources',
    component: SourceAnalytics,
    meta: {
      requiresAuth: true,
      title: 'Analytics de Origem'
    }
  }
]
